import { DOWNLOAD_INVOICE_PDF_TOKEN_URL, makeGetApiRequest, makePostApiRequest, SPINNY_FILE_UPLOAD_FOR_CATALOGUE } from "../common";
import { useQuery, useLazyQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

type filterType = {
  key: string;
  value: any;
};

type onChangefilterType = (onChangeFilter: filterType[], isAppend?: boolean) => any;

export const customAxios = async <T extends any = any>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
  try {
    const response = await axios?.(config);
    return response;
  } catch (e) {
    throw Error(e?.response?.data?.message ?? e?.message ?? "Axios error with no message");
  }
};

export function toTwoDecimalNo(str: number | string) {
  return str
    .toString()
    .split(".")
    .map((value, index) => {
      if (index === 1) {
        return value.slice(0, 2);
      }
      return value;
    })
    .join(".");
}

export const isIntegerNumber = (text: string | number) => {
  return /^\d+$/.test(text.toString());
};

export const isFloatingNumber = (text: string | number) => {
  return /^\d*[.]{0,1}(\d+)?$/.test(text.toString());
};

export const isAlpha = (char) => {
  return (char >= "a" && char <= "z") || (char >= "A" && char <= "Z");
};

export const checkDataFullFilled = (mjrData) => {
  const partCost = mjrData.partCost;
  const partCount = mjrData.partCount;
  const labourCost = mjrData.labourCost;
  const isHsnRequired = partCost && Number(partCost) > 0;
  const isSacRequired = labourCost && Number(labourCost) > 0;
  const f1 = isSacRequired ? !!mjrData.sac : true;
  const f2 = isHsnRequired ? !!mjrData.hsn : true;
  const f3 = !!mjrData.part;
  const f4 = !!mjrData.fix;
  return f1 && f2 && f3 && f4;
};

export const toCamelCase = (str: string) => {
  return str.replace(/_([a-z0-9])/g, function (g) {
    return g[1].toUpperCase();
  });
};

export const toTitleCase = (str: String) => {
  return str;
};

export const openURL = (url: string, options?: any) => {
  let a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.click();
};

export const downloadInvoice = (invoice_id) => {
  const token = localStorage.getItem("token");
  const workshopId = localStorage.getItem("workshopId");
  const url = `${DOWNLOAD_INVOICE_PDF_TOKEN_URL}?invoice_id=${parseInt(invoice_id)}&entity_id=${workshopId}`;

  makeGetApiRequest(url, {}, "Keycloak-Authorization", "Bearer", "refurb")
    .then((resData) => {
      if (resData.status === 200) {
        let URL = resData?.data?.URL;
        openURL(`${URL}`);
      }
    })
    .catch((e) => {
      alert(e);
    });
};

export const printHtmlAsPdf = (html: string) => {
  try {
    if (!html) {
      throw new Error("Missing html content");
    }
    const blob = new Blob([html], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url);
    newWindow.addEventListener("load", () => {
      newWindow.print();
    });
    newWindow.addEventListener("afterprint", () => {
      newWindow.close();
    });
  } catch {
    showAlert("Error: Could not download file", "error");
  }
};

export const onChangeFilters = (setFilters: any, filters: { key: string; value: { valueField: string }[] }[]) => {
  // To remove existing filter need to send key with value blank array.
  if (filters.length > 0) {
    setFilters((prevState) => {
      let newState = [...prevState];
      filters.forEach((obj) => {
        // Invalidate old keys for obj.key
        newState = newState.filter((new_obj) => new_obj.key !== obj.key);
        newState.push(
          ...obj.value.map((val) => {
            return { key: obj.key, value: val };
          })
        );
      });
      return newState;
    });
  } else {
    setFilters([]);
  }
};

export const preDefinedRefurbCategory = {
  PRE_SALE: "PRE_SALE",
  POST_SALE: "POST_SALE",
  REFURB: "REFURB",
  OTHER: "OTHER",
  PRE_SALE_REWORK: "PRE_SALE_REWORK",
  PRE_SALE_CAR_RECEIVING_AT_HUB: "PRE_SALE_CAR_RECEIVING_AT_HUB",
  PRE_SALE_MAINTENANCE: "PRE_SALE_MAINTENANCE",
  PRE_SALE_CAR_DELIVERY: "PRE_SALE_CAR_DELIVERY",
  POST_SALE_WARRANTY: "POST_SALE_WARRANTY",
  POST_SALE_B2C: "POST_SALE_B2C",
  REPAIR_AND_SERVICES: "REPAIR_AND_SERVICES",
  FIVE_DAY_MONEY_BACK: "FIVE_DAY_MONEY_BACK",
  BUDGET: "BUDGET",
  PRE_SALE_CR_REVALIDATION: "PRE_SALE_CR_REVALIDATION",
  PRE_SALE_HR_REVALIDATION: "PRE_SALE_HR_REVALIDATION",
  PRE_SALE_REWORK_REVALIDATION: "PRE_SALE_REWORK_REVALIDATION",
  PRE_SALE_MR_REVALIDATION: "PRE_SALE_MR_REVALIDATION",
  INSURANCE: "INSURANCE",
  REFURB_DETAILING: "REFURB_DETAILING",
  PRE_SALE_DEMAND_INSPECTION: "PRE_SALE_DEMAND_INSPECTION",
  SERVICING: "SERVICING",
  POST_SALE_WARRANTY_5DMB:"POST_SALE_WARRANTY_5DMB"
};

export const preDefinedRefurbStrings = {
  PRE_SALE: "Pre Sale",
  POST_SALE: "Post Sale",
  REFURB: "Refurb",
  OTHER: "Other",
  PRE_SALE_REWORK: "Pre Sale: Rework",
  PRE_SALE_CAR_RECEIVING_AT_HUB: "Pre Sale: Car receiving at Hub",
  PRE_SALE_MAINTENANCE: "Pre Sale: Maintenance",
  PRE_SALE_CAR_DELIVERY: "Pre Sale: Car Delivery",
  PRE_SALE_CR_REVALIDATION: "Pre Sale: CR Revalidation",
  PRE_SALE_HR_REVALIDATION: "Pre Sale: HR Revalidation",
  PRE_SALE_MR_REVALIDATION: "Pre Sale: MR Revalidation",
  PRE_SALE_REWORK_REVALIDATION: "Pre Sale: Rework Revalidation",
  POST_SALE_WARRANTY: "Post Sale: Warranty",
  POST_SALE_B2C: "Post Sale: B2C",
  REPAIR_AND_SERVICES: "Repair and Services",
  FIVE_DAY_MONEY_BACK: "Five Day Money Back",
  BUDGET: "Budget",
  INSURANCE: "Insurance",
  PRE_SALE_DEMAND_INSPECTION: "Pre Sale: Demand Inspection",
  SERVICING: 'Servicing',
  POST_SALE_WARRANTY_5DMB:'Warranty 5DMB'
};

export const transmissionType = {
  N_A: "N/A",
  MANUAL: "Manual",
  AUTOMATIC: "Automatic",
};

export const fuelTypeStrings = (fuelType) => {
  const fuelTypeEnum = {
    N_A: "N/A",
    "N/A": "N/A",
    PETROL: "Petrol",
    PETROL_CNG: "Petrol + CNG",
    "PETROL+CNG": "Petrol + CNG",
    DIESEL: "Diesel",
    CNG: "CNG",
    LPG: "LPG",
    PETROL_LPG: "Petrol + LPG",
    "PETROL+LPG": "Petrol + LPG",
    ELECTRIC: "Electric",
    HYBRID: "Hybrid",
  };
  return fuelTypeEnum[fuelType] ? fuelTypeEnum[fuelType] : fuelType;
};

export const podValueString = {
  BS: "Bodyshop",
  Detailing: "Detailing",
  MECH: "Mechanical",
  BS_AND_DETAILING: "BS and Detailing",
  ACEL: "AC and Electricals",
  P4: "Engine",
  ABC: "Wheel and Tyres",
  OTHER: "Other",
  ACS: "Accessories",
};

export const carCategoryMapping = {
  ASSURED: "A",
  BCM: "B",
  BUDGET: "BD",
  N_A: "--",
  NOT_OK: "NOK",
};

export const getRefurbCategories = (isAddCar = false, isCreateInvoice = false) => {
  const categories = [{ value: preDefinedRefurbCategory.REFURB, displayName: "Refurb" }];
  if (!isAddCar) {
    if (!isCreateInvoice) {
      categories.push(
        { value: preDefinedRefurbCategory.PRE_SALE, displayName: "Pre Sale" },
        { value: preDefinedRefurbCategory.POST_SALE, displayName: "Post Sale" },
        { value: preDefinedRefurbCategory.REPAIR_AND_SERVICES, displayName: "Repair and Services" }
      );
    }
    categories.push(
      { value: preDefinedRefurbCategory.PRE_SALE_REWORK, displayName: "Rework" },
      { value: preDefinedRefurbCategory.PRE_SALE_CAR_RECEIVING_AT_HUB, displayName: "Pre Sale: Car receiving at Hub" },
      { value: preDefinedRefurbCategory.PRE_SALE_MAINTENANCE, displayName: "Pre Sale: Maintenance" },
      { value: preDefinedRefurbCategory.PRE_SALE_CAR_DELIVERY, displayName: "Pre Sale: Car Delivery" }
    );
  }
  categories.push({ value: preDefinedRefurbCategory.POST_SALE_WARRANTY, displayName: "Warranty" });
  categories.push({ value: preDefinedRefurbCategory.POST_SALE_WARRANTY_5DMB, displayName: "Post Sale Warranty 5DMB" });
  categories.push({ value: preDefinedRefurbCategory.POST_SALE_B2C, displayName: "Post Sale: B2C" });
  categories.push({
    value: preDefinedRefurbCategory.PRE_SALE_CR_REVALIDATION,
    displayName: "Pre Sale CR Revalidation",
  });
  categories.push({
    value: preDefinedRefurbCategory.PRE_SALE_HR_REVALIDATION,
    displayName: "Pre Sale HR Revalidation",
  });
  categories.push({
    value: preDefinedRefurbCategory.PRE_SALE_REWORK_REVALIDATION,
    displayName: "Pre Sale Rework Revalidation",
  });
  categories.push({
    value: preDefinedRefurbCategory.PRE_SALE_MR_REVALIDATION,
    displayName: "Pre Sale MR Revalidation",
  });
  categories.push({ value: preDefinedRefurbCategory.INSURANCE, displayName: "Insurance" });
  categories.push({ value: preDefinedRefurbCategory.FIVE_DAY_MONEY_BACK, displayName: "Five Day Money Back" });
  categories.push({ value: preDefinedRefurbCategory.REFURB_DETAILING, displayName: "Refurb Detailing" });
  categories.push({
    value: preDefinedRefurbCategory.PRE_SALE_DEMAND_INSPECTION,
    displayName: "Pre Sale: Demand Inspection",
  });
  categories.push({
    value: preDefinedRefurbCategory.SERVICING,
    displayName: 'Servicing'
  })
  return categories;
};

export const getDisplayNameForRefurbCategory = (category: string) => {
  const item = getRefurbCategories().filter((obj) => obj.value === category);
  return item.length > 0 ? item[0].displayName : category;
};

export const workTypeColumn = {
  PRE_SALE: "Pre Sale",
  POST_SALE: "Post Sale",
  REPAIR_AND_SERVICES: "Repair and Services",
  REFURB: "Refurb",
  OTHER: "OTHER",
  PRE_SALE_REWORK: "Rework",
  PRE_SALE_CAR_RECEIVING_AT_HUB: "Pre Sale: Car receiving at Hub",
  PRE_SALE_MAINTENANCE: "Pre Sale: Maintenance",
  PRE_SALE_CAR_DELIVERY: "Pre Sale: Car Delivery",
  POST_SALE_WARRANTY: "Warranty",
  POST_SALE_B2C: "Post Sale: B2C",
  FIVE_DAY_MONEY_BACK: "5DMB",
  PRE_SALE_CR_REVALIDATION: "Pre Sale: CR Revalidation",
  PRE_SALE_HR_REVALIDATION: "Pre Sale: HR Revalidation",
  PRE_SALE_MR_REVALIDATION: "Pre Sale: MR Revalidation",
  PRE_SALE_REWORK_REVALIDATION: "Pre Sale: Rework Revalidation",
  INSURANCE: "Insurance",
  REFURB_DETAILING: "Refurb Detailing",
  PRE_SALE_DEMAND_INSPECTION: "Pre Sale: Demand Inspection",
  SERVICING: 'Servicing',
  POST_SALE_WARRANTY_5DMB:'Warranty 5DMB'
};

export const preDefinedJobListInspectionStatus = {
  N_A: "N/A",
  NOT_OK: "NOT_OK",
  BCM: "BCM",
  ASSURED: "ASSURED",
  AUCTION: "AUCTION",
  LUXURY: "LUXURY",
  BUDGET: "BUDGET",
};

export const statusTypes = {
  DRAFT: "DRAFT",
  OPEN: "OPEN",
  COMPLETED: "COMPLETED",
  CLOSED: "CLOSED",
};

export const requestTypes = {
  INVENTORY_REPLENISHMENT: "INVENTORY_REPLENISHMENT",
  JOB_CARD_FULFILMENT: "JOB_CARD_FULFILMENT",
  TRANSFER_ORDER_REQUEST: "TRANSFER_ORDER_REQUEST",
};

export const SPARES_SCREENS = {
  issueRequest: "ISSUE_REQUEST",
  inventoryReplenishment: "PR_INVENTORY_REPLENISHMENT",
  jobFulfilment: "PR_JOB_FULFILMENT",
  jobFulfilmentCar: "PR_JOB_FULFILMENT-BY_CAR_VIEW",
  inventoryManagement: "INVENTORY_MANAGEMENT",
  partReceivingVendor: "PART_RECEIVING_VIA_VENDOR",
  partReceivingTO: "PART_RECEIVING_VIA_TRANSFER_ORDER",
  raiseRequest: "RAISE_INVENTORY_REQUEST",
  alternateRequest: "ALTERNATE_REQUEST_MANAGEMENT",
  catManagement: "CATALOGUE_MANAGEMENT",
  dispute: "CONFLICT_MANAGEMENT",
  resolution: "RESOLUTION_MANAGEMENT",
  jobCardManagement: "JOB_CARD_MANAGEMENT",
  catalogueManagementV2: "CATALOGUE_MANAGEMENT_V2",
};

export const SPARES_SCREENS_SEQ = {
  ISSUE_REQUEST: 4,
  PR_INVENTORY_REPLENISHMENT: 3,
  PR_JOB_FULFILMENT: 1,
  "PR_JOB_FULFILMENT-BY_CAR_VIEW": 2,
  INVENTORY_MANAGEMENT: 5,
  PART_RECEIVING_VIA_VENDOR: 6,
  PART_RECEIVING_VIA_TRANSFER_ORDER: 7,
  RAISE_INVENTORY_REQUEST: 8,
  ALTERNATE_REQUEST_MANAGEMENT: 9,
  CATALOGUE_MANAGEMENT: 10,
  CATALOGUE_MANAGEMENT_V2: 11,
};

export const getCarCategories = () => {
  return [
    { value: preDefinedJobListInspectionStatus.N_A, displayName: "N/A" },
    { value: preDefinedJobListInspectionStatus.NOT_OK, displayName: "Not Ok" },
    { value: preDefinedJobListInspectionStatus.BCM, displayName: "BCM" },
    { value: preDefinedJobListInspectionStatus.ASSURED, displayName: "ASSURED" },
    { value: preDefinedJobListInspectionStatus.AUCTION, displayName: "AUCTION" },
    { value: preDefinedJobListInspectionStatus.LUXURY, displayName: "LUXURY" },
    { value: preDefinedJobListInspectionStatus.BUDGET, displayName: "BUDGET" },
  ];
};

export const getStatusTypeCategories = () => {
  return [
    { value: statusTypes.OPEN, displayName: "OPEN" },
    { value: statusTypes.CLOSED, displayName: "CLOSED" },
  ];
};

export const getReqestTypeCategories = () => {
  return [
    {
      value: requestTypes.INVENTORY_REPLENISHMENT,
      displayName: "INVENTORY REPLENISHMENT",
    },
    {
      value: requestTypes.JOB_CARD_FULFILMENT,
      displayName: "JOB CARD FULFILMENT",
    },
    {
      value: requestTypes.TRANSFER_ORDER_REQUEST,
      displayName: "TRANSFER ORDER",
    },
  ];
};

export const getBrandTypeCategories = () => {
  return [
    {
      value: "oem",
      displayName: "OEM",
    },
    {
      value: "oes",
      displayName: "OES",
    },
    {
      value: "others",
      displayName: "Others",
    },
  ];
};

export const IS_LOOSE_ITEM_OPTIONS = [
  {
    id: 1,
    label: "Yes",
    value: true,
  },
  {
    id: 2,
    label: "No",
    value: false,
  },
];

export const PACKING_TYPE_OPTIONS = [
  {
    id: 1,
    label: "Open",
    value: "OPEN",
  },
  {
    id: 2,
    label: "Packet",
    value: "PACKET",
  },
  {
    id: 3,
    label: "Barrel",
    value: "BARREL",
  },
  {
    id: 4,
    label: "Box",
    value: "BOX",
  },
  {
    id: 5,
    label: "Container",
    value: "CONTAINER",
  },
];

export const VERIFIED_OPTIONS = [
  {
    id: 1,
    label: "Yes",
    value: true,
  },
  {
    id: 2,
    label: "No",
    value: false,
  },
];

export const getDisplayNameForCarCategory = (category: string) => {
  const item = getCarCategories().filter((obj) => obj.value === category);
  return item.length > 0 ? item[0].displayName : category;
};

export const getSanitiseNumber = (mobileNumber) => {
  if (!mobileNumber) {
    return "";
  }
  mobileNumber = mobileNumber.toString();
  mobileNumber = mobileNumber.replace(/\D/g, "");
  if (mobileNumber.length === 10) mobileNumber = "91" + mobileNumber;
  else if (mobileNumber.length === 11 && mobileNumber[0] === "0") mobileNumber = "91" + mobileNumber.substring(1);
  return mobileNumber;
};

export const getTrimmedFileName = (fileName) => {
  if (!fileName) {
    return "";
  }
  fileName = fileName.toString();
  if (fileName.length > 10) {
    return fileName.substring(0, 4) + "..." + fileName.substring(fileName.length - 5);
  }
  return fileName;
};

export const getFileNameFromURL = (url) => {
  if (url) {
    let match = url.toString().match(/\/([^\/?#]+)[^\/]*$/);
    if (match && match.length > 1) {
      return match[1] + match[0];
    }
  }
  return url;
};

export const STATES = [
  { value: "ANDAMAN_AND_NICOBAR_ISLANDS", label: "Andaman and Nicobar Islands" },
  { value: "ANDHRA_PRADESH", label: "Andhra Pradesh" },
  { value: "ARUNACHAL_PRADESH", label: "Arunachal Pradesh" },
  { value: "ASSAM", label: "Assam" },
  { value: "BIHAR", label: "Bihar" },
  { value: "CHANDIGARH", label: "Chandigarh" },
  { value: "CHATTISGARH", label: "Chattisgarh" },
  { value: "DADRA_AND_NAGAR_HAVELI", label: "Dadra & Nagar Haveli" },
  { value: "DAMAN_AND_DIU", label: "Daman and Diu" },
  { value: "DELHI", label: "Delhi" },
  { value: "GOA", label: "Goa" },
  { value: "GUJARAT", label: "Gujarat" },
  { value: "HARYANA", label: "Haryana" },
  { value: "HIMACHAL_PRADESH", label: "Himachal Pradesh" },
  { value: "JAMMU_AND_KASHMIR", label: "Jammu & Kashmir" },
  { value: "JHARKHAND", label: "Jharkhand" },
  { value: "KARNATAKA", label: "Karnataka" },
  { value: "KERALA", label: "Kerala" },
  { value: "LAKSHADWEEP", label: "Lakshadweep" },
  { value: "MADHYA_PRADESH", label: "Madhya Pradesh" },
  { value: "MAHARASHTRA", label: "Maharashtra" },
  { value: "MANIPUR", label: "Manipur" },
  { value: "MEGHALAYA", label: "Meghalaya" },
  { value: "MIZORAM", label: "Mizoram" },
  { value: "NAGALAND", label: "Nagaland" },
  { value: "ODISHA", label: "Odisha" },
  { value: "PONDICHERRY", label: "Pondicherry" },
  { value: "PUNJAB", label: "Punjab" },
  { value: "RAJASTHAN", label: "Rajasthan" },
  { value: "SIKKIM", label: "Sikkim" },
  { value: "TAMILNADU", label: "Tamilnadu" },
  { value: "TELANGANA", label: "Telangana" },
  { value: "TRIPURA", label: "Tripura" },
  { value: "UTTAR_PRADESH", label: "Uttar Pradesh" },
  { value: "UTTARAKHAND", label: "Uttarakhand" },
  { value: "WEST_BENGAL", label: "West Bengal" },
];

export const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export const useDidUpdateEffect = (func, deps) => {
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) initialRender.current = false;
    else func();
  }, deps);
};

export const usePaginatedQuery = (query, options, persistentFilters = []) => {
  const { data, error, loading, refetch } = useQuery(query, options);

  const pageHandler = (page: number) => {
    setRefetchLoading(true);
    refetch({ page: Number(page) })
      .then(() => {
        setRefetchLoading(false);
      })
      .catch((e) => {
        alert(e.message);
      });
  };

  const filterHandler = (filters: any) => {
    setRefetchLoading(true);
    refetch({ page: 1, filters })
      .then((resData) => {
        // console.log(resData);
        setRefetchLoading(false);
      })
      .catch((e) => {
        alert(e.message);
      });
  };

  const searchHandler = (text: string) => {
    refetch({ page: 1, search: text })
      .then(() => {})
      .catch((e) => {
        alert(e.message);
      });
  };

  const pageHandlerWithSearch = (page: number = 1, text: string) => {
    refetch({ page: Number(page), search: text })
      .then(() => {})
      .catch((e) => {
        alert(e.message);
      });
  };

  const sortHandler = (sortData: { selector: string; direction: "desc" | "asc" }[]) => {
    const column_selector = sortData
      .map((obj) => {
        return obj.direction === "desc" ? `-${obj.selector}` : obj.selector;
      })
      .join(".");

    /*
     * TODO -> Convert single order by to string of more than one columns
     * */
    refetch({ page: 1, orderBy: column_selector })
      .then((resData) => {
        console.log(resData);
      })
      .catch((e) => {
        alert(e.message);
      });
  };

  const reload = (options) => {
    setRefetchLoading(true);
    refetch({ ...options })
      .then((res) => {
        setRefetchLoading(false);
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const [localFilters, setLocalFilters] = useState(
    !!options?.variables?.filters?.length ? options.variables.filters : []
  );
  const [refetchLoading, setRefetchLoading] = useState(false);

  const onChangeFilter: onChangefilterType = (filters, isAppend = true) => {
    if (isAppend) {
      onChangeFilters(setLocalFilters, filters);
    } else {
      setLocalFilters(filters);
    }
  };

  const applyFilterHandler = () => {
    filterHandler([
      ...localFilters.map((obj) => {
        let val = obj.value;
        val = typeof val === "object" ? val[val.valueField] : val;
        return { key: obj.key, value: val };
      }),
      ...persistentFilters,
    ]);
  };

  useDidMountEffect(applyFilterHandler, [localFilters]);

  return {
    data,
    error,
    loading,
    refetch,
    pageHandler,
    searchHandler,
    sortHandler,
    onChangeFilter,
    pageHandlerWithSearch,
    localFilters,
    refetchLoading,
    reload,
  };
};

export const useLazyPaginatedQuery = (query, options, persistentFilters = []) => {
  const [getQueryData, { data, error, called, loading, refetch }] = useLazyQuery(query, options);

  const pageHandler = (page: number) => {
    getQueryData({ variables: { page: Number(page) } });
  };

  const pageHandlerWithSearch = (page: number, text: string, filters?: any) => {
    if (!!filters) {
      getQueryData({ variables: { page: Number(page), search: text, filters } });
    } else {
      getQueryData({ variables: { page: Number(page), search: text } });
    }
  };

  const filterHandler = (filters: any) => {
    getQueryData({ variables: { page: 1, filters } });
  };

  const searchHandler = (text: string) => {
    getQueryData({ variables: { page: 1, search: text } });
  };

  const searchHandlerWithFilters = (text: string, filters?: any) => {
    getQueryData({
      variables: {
        page: 1,
        search: text,
        filters:
          filters?.length > 0
            ? filters
            : [
                ...localFilters.map((obj) => {
                  let val = obj.value;
                  val = typeof val === "object" ? val[val.valueField] : val;
                  return { key: obj.key, value: val };
                }),
                ...persistentFilters,
              ],
      },
    });
  };

  const sortHandler = (sortData: { selector: string; direction: "desc" | "asc" }[]) => {
    const column_selector = sortData
      .map((obj) => {
        return obj.direction === "desc" ? `-${obj.selector}` : obj.selector;
      })
      .join(".");

    /*
     * TODO -> Convert single order by to string of more than one columns
     * */
    getQueryData({ variables: { page: 1, orderBy: column_selector } });
  };

  const reload = (options) => {
    setRefetchLoading(true);
    refetch({ ...options })
      .then((res) => {
        setRefetchLoading(false);
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const [localFilters, setLocalFilters] = useState(
    !!options?.variables?.filters?.length ? options.variables.filters : []
  );
  const [refetchLoading, setRefetchLoading] = useState(false);

  const onChangeFilter: onChangefilterType = (filters, isAppend = true) => {
    if (isAppend) {
      onChangeFilters(setLocalFilters, filters);
    } else {
      setLocalFilters(filters);
    }
  };

  const applyFilterHandler = () => {
    filterHandler([
      ...localFilters.map((obj) => {
        let val = obj.value;
        val = typeof val === "object" ? val[val.valueField] : val;
        return { key: obj.key, value: val };
      }),
      ...persistentFilters,
    ]);
  };

  useDidMountEffect(applyFilterHandler, [localFilters]);

  return [
    getQueryData,
    {
      data,
      called,
      error,
      loading,
      refetch,
      pageHandler,
      searchHandler,
      pageHandlerWithSearch,
      sortHandler,
      onChangeFilter,
      searchHandlerWithFilters,
      localFilters,
      refetchLoading,
      reload,
    },
  ];
};

export const checkValidMessage = (t) => {
  return !!t && !!t.trim();
};

export function getDeepSearchedItems(list: any[], searchText: string, searchKey: string) {
  const items = searchText.toLowerCase().split(" ");
  return list.filter(
    (obj) => items.map((item) => obj[searchKey].toLowerCase().includes(item)).filter((obj2) => !obj2).length === 0
  );
}

export const isEmptyObject = (obj) => {
  if (!obj) return !obj;
  return Object.keys(obj).length === 0;
};
export const compare = (a: any, b: any, type: "ASC" | "DESC") => {
  const isAsc = type === "ASC";
  if (a > b) {
    return isAsc ? 1 : -1;
  }
  if (b > a) {
    return isAsc ? -1 : 1;
  }
  return 0;
};

export const DOCUMENT_TYPES = [
  {
    name: "Invoice",
    value: "INVOICE",
  },
  {
    name: "Challan",
    value: "CHALLAN",
  },
  {
    name: "Performa Invoice",
    value: "PERFORMA_INVOICE",
  },
];

export const PRICE_TYPES = [
  {
    name: "Listing Price",
    value: "LISTING_PRICE",
  },
  {
    name: "MRP",
    value: "MRP",
  },
];

export const TAX_TYPES = [
  {
    name: "5%",
    value: "FIVE",
    taxPercent: 5,
  },
  {
    name: "9%",
    value: "NINE",
    taxPercent: 9,
  },
  {
    name: "12%",
    value: "TWELVE",
    taxPercent: 12,
  },
  {
    name: "18%",
    value: "EIGHTEEN",
    taxPercent: 18,
  },
  {
    name: "28%",
    value: "TWENTY_EIGHT",
    taxPercent: 28,
  },
];

export const HSN_TAX_CODES = [
  {
    id: 84,
    code: "150500",
    type: "HSN",
  },
  {
    id: 83,
    code: "870899",
    type: "HSN",
  },
  {
    id: 82,
    code: "842199",
    type: "HSN",
  },
  {
    id: 1,
    code: "520811",
    type: "HSN",
  },
];

export const INVENTORY_CAR_STATUSES = [
  { displayName: "Technician Assignment Pending", value: "TECHNICIAN_ASSIGNMENT_PENDING" },
  { displayName: "Work start pending", value: "WORK_START_PENDING" },
  { displayName: "Work in progress", value: "WORK_IN_PROGRESS" },
  { displayName: "Technician closure pending", value: "TECHNICIAN_CLOSURE_PENDING" },
  { displayName: "Invoice pending", value: "INVOICE_PENDING" },
  { displayName: "Waiting for parts", value: "WAITING_FOR_PARTS" },
  { displayName: "Verification Pending", value: "VERIFICATION_PENDING" },
  { displayName: "Joblists on Hold", value: "JOBLIST_ON_HOLD" },
  { displayName: "Ready to be picked", value: "READY_TO_BE_PICKED" },
];

export const STOCK_OUT_REASONS_ENUM = {
  DAMAGED_PART: "DAMAGED_PART",
  RETURNED_TO_VENDOR: "RETURNED_TO_VENDOR",
  SENT_TO_ANOTHER_WORKSHOP: "SENT_TO_ANOTHER_WORKSHOP",
  LOST: "LOST",
  CONSUMABLES_ISSUED_TO_CGT: "CONSUMABLES_ISSUED_TO_CGT",
  INVENTORY_CORRECTION: "INVENTORY_CORRECTION",
  SCRAP_LIQUIDATION: "SCRAP_LIQUIDATION",
  SOLD_LIQUIDATION: "SOLD_LIQUIDATION",
};

export const STOCK_OUT_REASONS = [
  {
    displayName: "Damaged Part",
    value: "DAMAGED_PART",
    isDisabled: true,
  },
  {
    displayName: "Returned To Vendor",
    value: "RETURNED_TO_VENDOR",
  },
  {
    displayName: "Sent To Another Workshop",
    value: "SENT_TO_ANOTHER_WORKSHOP",
  },
  {
    displayName: "Lost",
    value: "LOST",
  },
  {
    displayName: "Consumables Issued To CGT",
    value: "CONSUMABLES_ISSUED_TO_CGT",
  },
  {
    displayName: "Inventory Correction",
    value: "INVENTORY_CORRECTION",
  },
  {
    displayName: "Scrap Liquidation",
    value: "SCRAP_LIQUIDATION",
  },
  {
    displayName: "Sold Liquidation",
    value: "SOLD_LIQUIDATION",
  },
];

export const CGT_CHANGE_REASONS = [
  // { value: 'CGT is not present on that day/time slot', label: 'CGT is <b>not present</b> on that day/time slot' },
  {
    value: "CGT has a lot of WIP cars which require multiple follow-ups",
    label: "CGT has <b>a lot of WIP cars</b> which require multiple follow-ups",
  },
  { value: "CGT is not skilled/ confident in that brand", label: "CGT is not skilled/ confident in that <b>brand</b>" },
  {
    value: "CGT is not skilled/ confident in this level of work complexity",
    label: "CGT is not skilled/ confident in this level of <b>work complexity</b>",
  },
  { value: "Different CGT has more bandwidth", label: "Different CGT has <b>more bandwidth</b>" },
];

export const UNIT_DATA = [
  { name: "GM", displayName: "GRAM" },
  { name: "KG", displayName: "KILOGRAM" },
  { name: "PC", displayName: "PIECES" },
  { name: "L", displayName: "LITRE" },
  { name: "ML", displayName: "MILLILITRE" },
  { name: "MM", displayName: "MILLIMETER" },
  { name: "M", displayName: "METER" },
  { name: "INCH", displayName: "INCH" },
];

export const to3Dec = (text) => {
  if ((text.split(".").length > 1 && text.split(".")[1].length > 3) || text.split(".").length > 2) {
    return false;
  }
  return true;
};

export const decimalCheck = (text) => {
  var reg = new RegExp(/^(\d+)?(\.\d{1,3})?$/);
  if (reg.test(text) && to3Dec(text)) {
    return true;
  }
  return false;
};

export const validatedPrice = (text: string) => {
  const charLastEntered = text.slice(-1);
  if (text === "" || (text.indexOf(".") == -1 && parseInt(text) === 0)) {
    return "0";
  }

  if (
    (!Number.isNaN(parseInt(charLastEntered)) &&
      (text.indexOf(".") != -1 ? text.length - text.indexOf(".") < 4 : true)) ||
    (charLastEntered == "." && text.indexOf(".") == text.lastIndexOf("."))
  ) {
    return text.startsWith("0") && text.charAt(1) == "." ? text : text.replace(/^0+/, "");
  } else {
    return text.substring(0, text.length - 1);
  }
};

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export function reviver(key, value) {
  if (typeof value === "object" && value !== null) {
    if (value.dataType === "Map") {
      return new Map(value.value);
    }
  }
  return value;
}

export function replacer(key, value) {
  if (value instanceof Map) {
    return {
      dataType: "Map",
      value: Array.from(value.entries()), // or with spread: value: [...value]
    };
  } else {
    return value;
  }
}

export function showAlert(message, severity) {
  const event = new CustomEvent("onShowAlert", { detail: { message, severity } });
  document.dispatchEvent(event);
}

export const workshopRefurbCarStatus = {
  workStartPending: "WORK_START_PENDING",
  technicianAssignmentPending: "TECHNICIAN_ASSIGNMENT_PENDING",
  waitingForParts: "WAITING_FOR_PARTS",
  workInProgress: "WORK_IN_PROGRESS",
  joblistOnHold: "JOBLIST_ON_HOLD",
  joblistReadyToBePicked: "JOBLIST_READY_TO_BE_PICKED",
  remainingParts: "REMAINING_PARTS",
  waitingForAdhocParts: "WAITING_FOR_ADHOC_PARTS",
  verificationPending: "VERIFICATION_PENDING",
  partReceivingPending: "PART_RECEIVING_PENDING",
};

export const getQuantities = (productData, productId) => {
  let quantities = { availableQuantity: 0, inStockQuantity: "" };
  if (productData && productData?.length > 0) {
    let indx = productData?.findIndex((element) => element?.productId === productId);
    quantities.availableQuantity = productData[indx]?.availableQuantity ? productData[indx]?.availableQuantity : 0;
    quantities.inStockQuantity = productData[indx]?.inStockQuantity ? productData[indx]?.inStockQuantity : "";
  }
  return quantities;
};

export const getTimeDiff = (createdAtTime) => {
  var now = moment(new Date()); //todays date
  var end = moment(createdAtTime); // another date
  const timeGap = moment.duration(now.diff(end));
  var duration = Math.floor(Math.abs(timeGap.asHours()));
  var durationInMin = Math.floor(Math.abs(timeGap.asMinutes()));

  const hrs = duration % 24;
  const hrString = hrs > 1 ? `${hrs}Hrs` : hrs == 1 ? "1Hr" : `${durationInMin}Min`;
  return duration >= 24 ? `${Math.floor(duration / 24)}D ${hrs >= 1 ? hrString : ""}` : hrString;
  // return b.fromNow(true).replace('minutes', 'min').replace('days', 'D').replace('hours', 'H').replace('months', 'M');
};

export const minutesToFormat = (minutes) => {
  const duration = moment.duration(minutes, "minutes");

  const years = Math.floor(duration.asYears());
  duration.subtract(moment.duration(years, "years"));

  const months = Math.floor(duration.asMonths());
  duration.subtract(moment.duration(months, "months"));

  const days = Math.floor(duration.asDays());
  duration.subtract(moment.duration(days, "days"));

  const hours = duration.hours();
  const mins = duration.minutes();

  let formattedDuration = `${years > 0 ? `${years}Y ` : ""}${months > 0 ? `${months}M ` : ""}${days > 0 ? `${days}D ` : ""}${hours > 0 ? `${hours}hrs ` : ""}${mins >= 0 ? `${mins}min ` : ""}`;
  if (typeof minutes !== "number") formattedDuration = "--";
  return formattedDuration;
};

export const isTransferOrder = (documentType: string) => {
  return (
    documentType === "INTERNAL_STOCK_TRANSFER" || // TODO: to be removed
    documentType === "VENDOR_STOCK_TRANSFER" || // TODO: to be removed
    documentType === "DL_CHALLAN" ||
    documentType === "TRANSFER_INVOICE" ||
    documentType === "TRANSFER_ORDER"
  );
};

export function withOpacity(hex: string, opacity: number) {
  // Ensure opacity is within the range [0, 1]
  opacity = Math.min(1, Math.max(0, opacity));
  // Parse the hex color into RGB components
  const bigint = parseInt(hex.substring(1), 16);
  const red = (bigint >> 16) & 255;
  const green = (bigint >> 8) & 255;
  const blue = bigint & 255;
  // Return the hexa color string
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}

type SelectedWorkshop = {
  workshopId: number;
  displayName: string;
  workshopType: string;
  isDashboardStatVisible: boolean;
};

export const getSelectedWorkshop = (): SelectedWorkshop | null => {
  let workshopId: any = localStorage.getItem("workshopId");
  workshopId = workshopId ? parseInt(workshopId) : null;

  const workshopData: { id: string; displayName: string; isDashboardStatVisible: boolean; workshopType: string } =
    JSON.parse(localStorage.getItem("userMetaData"))?.workshop ?? {};

  if (!workshopId) return null;

  return { workshopId: workshopId as number, ...workshopData };
};

export const carDetailsToString = <
  T extends {
    year: number | string;
    make: string;
    model: string;
    variant: string;
  },
>({
  year,
  make,
  model,
  variant,
}: T) => {
  return [year, make, model, variant].filter(Boolean).join(" ");
};

export const joinWithInArray = <T,>(items: T[], separator: T): T[] => {
  if (items.length === 0) return [];

  const filteredItems = items.filter(Boolean);

  const result: T[] = [];
  for (let i = 0; i < filteredItems.length; i++) {
    result.push(filteredItems[i]);
    if (i < filteredItems.length - 1) {
      result.push(separator);
    }
  }
  return result;
};

export const genericFileUpload = async (files: File[]): Promise<string[]> => {
  const uploadPromises = files.map(async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('auto_enhance', 'false');
    
    try {
      const resp = await makePostApiRequest(SPINNY_FILE_UPLOAD_FOR_CATALOGUE, formData, {}, 'Keycloak-Authorization', 'Bearer', 'sso');
      return resp?.data.file_upload_slug;
    } catch (error) {
      showAlert("Failed to upload image", "error");
      throw error;
    }
  });
  
  return Promise.all(uploadPromises);
};

export const handleNavigationWithModifier = (
  routeName: string,
  routePath: string,
  params: Record<string, any>,
  navigation: any,
  event?: any,
  platform: string = typeof window !== 'undefined' ? 'web' : 'native'
) => {
  const isWeb = platform === "web";
  const isModifierPressed = event?.nativeEvent && (event.nativeEvent.metaKey || event.nativeEvent.ctrlKey);
  const shouldOpenInNewTab = isWeb && isModifierPressed;
  
  if (shouldOpenInNewTab) {
    // Build URL with query parameters
    const queryParams = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = String(value);
        }
        return acc;
      }, {} as Record<string, string>)
    ).toString();
    
    const url = queryParams ? `${routePath}?${queryParams}` : routePath;
    window.open(url, "_blank");
  } else {
    // Regular navigation
    navigation.navigate(routeName, params);
  }
};

export const openInNewTab = (
  routePath: string,
  params: Record<string, any>
) => {
  // Build URL with query parameters
  const queryParams = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        acc[key] = String(value);
      }
      return acc;
    }, {} as Record<string, string>)
  ).toString();
  
  const url = queryParams ? `${routePath}?${queryParams}` : routePath;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const sanitizeNumber = (value: string, disallowZero: boolean = false) => {
  let numericValue = value.replace(/[^0-9.]/g, "");
  
  // Remove leading zeros except for decimal numbers like "0.5"
  if (disallowZero) {
    numericValue = numericValue.replace(/^0+(?=\d)/, "");
    // If the result is just "0" or "0.", return empty string
    if (numericValue === "0" || numericValue === "0.") {
      return "";
    }
  }
  
  const parts = numericValue.split(".");
  let sanitizedValue = numericValue;
  if (parts.length > 2) {
    sanitizedValue = parts[0] + "." + parts.slice(1).join("");
  } else if (parts.length === 2 && parts[1].length > 2) {
    sanitizedValue = parts[0] + "." + parts[1].substring(0, 2);
  }
  
  // Final check for zero value
  if (disallowZero && (sanitizedValue === "0" || parseFloat(sanitizedValue) === 0)) {
    return "";
  }
  
  return sanitizedValue;
}